import { _get, _post } from "../../../Api";
import { toast } from "react-toastify";
import { setMerchant } from "../../../store/CloudActions";
import cloudStore from "../../../store/CloudStore";

export function getPaynlMerchants(apiToken) {
  let url = "/nova/v2/paynl_merchants";
  if (apiToken) {
    url += "?api_token=" + apiToken;
  }
  return _get(url)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}

export function updatePaynlMerchant(paynlMerchant, newData, oldValues) {
  return updatePaynlMerchants([paynlMerchant], [newData], [oldValues]).then((paynlMerchants) => {
    let merchant = cloudStore.merchant;
    merchant.paynl_merchant = paynlMerchants[0];
    setMerchant(merchant);
    return Promise.resolve(paynlMerchants[0]);
  });
}

export function updatePaynlMerchants(paynlMerchants, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in paynlMerchants) {
    data.push({
      paynlMerchantId: paynlMerchants[i]?.id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/paynl_merchants/update", data)
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}


export function getPaynlPinterminals() {
  let url = "/nova/v2/paynl_pinterminals";

  return _get(url)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
}
